import $bus from '@/script/eventbus'
import constant from '@/consts/const.json'
import router from '@/router'
import { clearAuthStorage, getValidToken } from '@/script/storageToken'
import { checkSentry } from '@/script/index'
import * as Sentry from '@sentry/vue'

/**
 * @description Обертка для ошибок Moodle
 * @param {Object} response Moodle API response
 */
export function MoodleError(response) {
    Error.call(this, 'LMS calling error')
    this.name = 'MoodleError'
    this.response = response.data

    const messages = []
    this.originalMessage = {}
    if (response.warnings?.length) {
        this.originalMessage.warnings = response.warnings
        messages.push(...response.warnings.map(el => el.message))
    }
    if (response.exception) {
        this.originalMessage.exception = response.exception
        this.originalMessage.errorcode = response.errorcode
        this.originalMessage.message = response.message
        messages.push(response.message)
    }

    // this.originalMessage = response
    this.message = 'Ошибка LMS: ' + messages.join('; ').replace(new RegExp('&lt;(.*?)&gt;', 'g'), '')

    if (Error.captureStackTrace) {
        Error.captureStackTrace(this, MoodleError)
    } else {
        this.stack = (new Error()).stack
    }

    // ** cache error to log
    $bus.emit('error', this)
    if (
        response?.errorcode === constant.errorCode.SITE_MAINTENANCE ||
        response?.errorcode === constant.errorCode.DB_CONNECTION_FAILED
    ) {
        router.push('/siteMaintenance')
    } else if (
        response?.errorcode === constant.errorCode.UPGRADE_RUNNING
    ) {
        router.push('/siteUpdating')
    } else if (
        response?.errorcode === constant.errorCode.NO_REVIEW
    ) {
        router.push(window.location.pathname.split('review')[0])
    } else if (response?.errorcode === constant.errorCode.REQUIRE_LOGIN_ERROR || response?.errorcode === constant.errorCode.COURSE_CONTEXT_NOT_VALID) {
        router.push(`/home`)
    } else if (response?.errorcode === constant.errorCode.INVALID_RECORD || response?.errorcode === constant.errorCode.INVALID_RECORD_UNKNOWN) {
        router.push({ name: '404' })
    } else if (response?.errorcode === constant.errorCode.INVALID_TOKEN && getValidToken()) {
        clearAuthStorage()
        document.location.reload()
    } else if (response?.errorcode === constant.errorCode.FORCE_PASSWORD_CHANGE_NOTICE) {
        router.push('/profile')
    } else if (checkSentry()) {
        Sentry.addBreadcrumb({
            category: response.exception ? response.exception : 'MoodleError',
            message: this.message,
            level: 'info',
            data: this
        })

        const userIsLogin = !!getValidToken()
        if (!userIsLogin) {
            Sentry.captureException(this)
        } else {
            Sentry.captureSession(false)
        }
    }
}

MoodleError.prototype = Object.create(Error.prototype)